import { useEffect, useState } from "react";
import { Slider } from "./ui/slider";
import { inr } from "../lib/api";

const MAX = 200000;
const STEPS = [0, 500, 1000, 2000, 5000, 10000, 20000, 30000, 50000, 75000, 100000, 150000, MAX];

export default function PriceRange({ sp, set }) {
  const [lo0, hi0] = (sp.get("price") || "").split("-").map(Number);
  const idx = (v, d) => (v ? STEPS.reduce((b, s, i) => (Math.abs(s - v) < Math.abs(STEPS[b] - v) ? i : b), 0) : d);
  const [r, setR] = useState([idx(lo0, 0), idx(hi0, STEPS.length - 1)]);
  useEffect(() => { setR([idx(lo0, 0), idx(hi0, STEPS.length - 1)]); }, [sp.get("price")]); // eslint-disable-line
  const apply = ([a, b]) => set("price", a === 0 && b === STEPS.length - 1 ? "" : `${STEPS[a]}-${b === STEPS.length - 1 ? 10000000 : STEPS[b]}`);
  return (
    <div data-testid="price-range">
      <div className="flex justify-between text-xs mb-3">
        <span data-testid="price-range-min" className="px-2 py-1 rounded-lg bg-white/5">{inr(STEPS[r[0]])}</span>
        <span data-testid="price-range-max" className="px-2 py-1 rounded-lg bg-white/5">{r[1] === STEPS.length - 1 ? `${inr(MAX)}+` : inr(STEPS[r[1]])}</span>
      </div>
      <Slider data-testid="price-range-slider" min={0} max={STEPS.length - 1} step={1} minStepsBetweenThumbs={1} value={r} onValueChange={setR} onValueCommit={apply} />
    </div>
  );
}
